import { SourceEmbeddingsComponent } from './source-embedings/source-embeddings.component';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Subscription } from 'rxjs';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { FoldersService } from '@shared/services/folders.service';

import { SourcesContentComponent } from '../sources-content/sources-content.component';
import { SourceReferencesComponent } from './source-references/source-references.component';

@Component({
    selector: 'app-sources-settings',
    templateUrl: './sources-settings.component.html',
    styleUrls: ['./sources-settings.component.scss'],
    standalone: true,
    imports: [
      MatIconButton,
      MatIcon,
      SourcesContentComponent,
      SourceEmbeddingsComponent,
      SourceReferencesComponent,
    ]
})
export class SourcesSettingsComponent implements OnInit, OnDestroy {
  public activeSection: 'general' | 'embeddings' | 'references' = 'general';
  @Input() source: TSourceItem = {} as TSourceItem;
  @Output() handleCloseSource = new EventEmitter();

  private _subscription: Subscription = new Subscription();
  public folderName = '';

  constructor(private _foldersService: FoldersService) {}

  ngOnInit(): void {
    // Ensure folders are loaded when component initializes
    this._foldersService.fetchFolders();

    // Subscribe to folders to get the folder name
    this._subscription.add(
      this._foldersService.getFoldersObservable().subscribe(folders => {
        this.updateFolderName(folders);
      })
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private updateFolderName(folders: any[]): void {
    if (this.source.folder && this.source.folder.length > 0) {
      const folderId = this.source.folder[0];
      const folder = folders.find(f => f._id === folderId);
      this.folderName = folder ? folder.title || folder.name : folderId;
    } else {
      this.folderName = '';
    }
  }

  public getDate(date: Date | undefined): string {
    const formattedDate = Date.parse(date as unknown as string);
    if (date && isNaN(formattedDate ?? NaN)) {
      return `Invalid date`;
    }
    return new Intl.DateTimeFormat('en-US').format(formattedDate);
  }

  public getFolderName(): string {
    return this.folderName;
  }

  public back(): void {
    if (this.source.folder[0]) {
      this.handleCloseSource.emit(this.source.folder[0]);
    }
  }

  public setActiveSection(section: 'general' | 'embeddings' | 'references'): void {
    this.activeSection = section;
  }
}
